function generateSrcset(baseUrl, sizes = [180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 1950, 2048]) {
    return sizes
        .map(width => {
            // Shopify images follow the pattern: originalname_600x.jpg
            // Replace width part or append if not present
            const url = baseUrl.replace(/_\d+x(\.\w+)$/, `_${width}x$1`);
            return `${url} ${width}w`;
        })
        .join(', ');
}

function changeImage(imgNode, loader, value, productId) {
    const newImageSrc = window.productImages[productId]?.find(el => el.alt == value)?.src;
    if (!newImageSrc) {
        console.warn('HULK CUSTOM - no image found');
        return;
    }
    loader.classList.remove('hulk-hidden');
    imgNode.onload = () => loader.classList.add('hulk-hidden');
    const newSrcSet = generateSrcset(newImageSrc);
    imgNode.setAttribute('src', newImageSrc);
    imgNode.setAttribute('srcset', newSrcSet);
}
function renderCollectionColor(option, element) {
    const swatch_data = JSON.parse(option.values_json || '[]');
    const optionWrapper = document.createElement('div');
    optionWrapper.classList.add('color-collection-wrapper');

    const MAX_SWATCH_DISPLAY = 3;
    let swatchCount = 0;
    let remainingSwatches = swatch_data.length - MAX_SWATCH_DISPLAY;

    for (const single_swatch of swatch_data) {
        if (swatchCount == MAX_SWATCH_DISPLAY) {
            break;
        }
        const swatchElement = document.createElement('label');
        swatchElement.classList.add('collection_swatch');

        const swatchInput = document.createElement('input');
        swatchInput.type = 'radio';
        swatchInput.id = 'collection_color_option_' + single_swatch[0].split(' ').join('_');
        swatchInput.name = 'collection page color option';
        swatchInput.value = single_swatch[0];
        swatchInput.classList.add('collection_swatch_input');

        const swatchVisual = document.createElement('span');
        swatchVisual.classList.add('collection_swatch_visual');

        const swatchHover = document.createElement('div');
        swatchHover.classList.add('collection_swatch_hover');

        swatchElement.appendChild(swatchInput);
        swatchElement.appendChild(swatchVisual);
        swatchElement.appendChild(swatchHover);

        swatchHover.innerHTML = `<p>${single_swatch[0]}</p>`;

        const fill_settings = single_swatch[2];
        if (fill_settings === 'color') {
            const colors = single_swatch[3]?.split(',') || [];
            if (colors.length === 2) {
                swatchVisual.style.cssText = `background: linear-gradient(to bottom, ${colors[0]} 0%,${colors[0]} 50%, ${colors[1]} 50%, ${colors[1]} 100%); border-radius: 100%; display: inline-block;`;
            } else if (colors.length === 1) {
                swatchVisual.style.cssText = `background: ${colors[0]}; border-radius: 100%; display: inline-block;`;
            }
        } else if (fill_settings === 'image') {
            swatchVisual.style.cssText = `display:block;width:50px;height:50px;background-image:url(${single_swatch[3]}); background-size:cover;background-position: center center;-webkit-border-radius: 50%;-moz-border-radius: 50%;border-radius: 50%;`;
        }

        optionWrapper.appendChild(swatchElement);
        swatchCount++;
    }
    if(remainingSwatches > 0) {
        const remainingSwatchesElement = document.createElement('a');
        remainingSwatchesElement.textContent = `+${remainingSwatches}`;
        remainingSwatchesElement.classList.add('remaining-swatches-indicator');

        // add product URL
        const productUrl = element.closest('.product-card-wrapper')?.querySelector('a')?.href;
        if (productUrl) {
            remainingSwatchesElement.href = productUrl;
        }

        optionWrapper.appendChild(remainingSwatchesElement);
    }
    element.appendChild(optionWrapper);
}